// import vuetify from "@/plugins/vuetify";

export const globalFunctions = {
  isDarkColor: (vuetify, color) => {
    console.log("vuetify => ", vuetify)
    const v = vuetify.theme.themes[vuetify.theme.isDark ? 'dark' : 'light'][color]
    var c = v ? v.substring(1) : color.substring(1);      // strip #
    var rgb = parseInt(c, 16);   // convert rrggbb to decimal
    var r = (rgb >> 16) & 0xff;  // extract red
    var g = (rgb >>  8) & 0xff;  // extract green
    var b = (rgb >>  0) & 0xff;  // extract blue

    var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

    if (luma > 128) {
      console.log(false)
      return false;
    } else {
      console.log(true)
      return true;
    }
  }
}